import AdminPolicy from './AdminPolicy';
import UserPolicy from './UserPolicy';
var instance = null;
var factory = {
    setCurrent: function (store) {
        instance = store.loggedInUserIsAdmin
            ? AdminPolicy
            : UserPolicy;
    },
    getCurrent: function () {
        return instance;
    }
};
export default factory;



//////////////////
// WEBPACK FOOTER
// ./src/services/DragDropPolicy/index.ts
// module id = 188
// module chunks = 0